<template>
  <div class="h_middle contents">
    <p class="info_txt">고객님의 <b>{{carNumber}}</b>차량은<br />
      현재 주차장에 없는 번호입니다.<br />
      다시 검색해 주시기 바랍니다.</p>
    <p class="btn2"><router-link to="/search">메인으로</router-link></p>
  </div>
</template>

<script>
  export default {
    name: 'empty',
    data() {
      return {
        carNumber: '',
      };
    },
    created() {
      this.carNumber = this.$store.getters.carNumber ? this.$store.getters.carNumber : sessionStorage.getItem('carNumber');
    }
  }
</script>

<style scoped>

</style>